<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1" lang="en-US"><a id="_idTextAnchor000"></a>queen lucia</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US">E. F. Benson</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US"><img src="image/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled216.vue?f20f98ec